import { FunctionComponent, useContext } from 'react';
import { LocationFormContext } from '../../context';
import { DETAILS } from '../const';
import { useMapStyles } from './styles';
import { Card } from '@mui/material';
import { SegmentGeometryMap } from 'components/LocationForm/SegmentGeometryMap';
import { LineString } from 'types';

export const LocationSegmentMap: FunctionComponent<{
  segmentColor: string;
  segmentOpacity: number;
}> = ({ segmentColor, segmentOpacity }) => {
  const { values, setValues, setDirty } = useContext(LocationFormContext);
  const classes = useMapStyles();

  const handleSegmentSelection = (geometry: LineString) => {
    setDirty(DETAILS, true);
    setValues((prev) => {
      return {
        ...prev,
        geometry,
      };
    });
  };

  return (
    <Card className={classes.fullHeight}>
      <SegmentGeometryMap
        geometry={values.geometry as LineString | undefined}
        onChange={handleSegmentSelection}
        segmentOpacity={segmentOpacity}
        segmentColor={segmentColor}
      />
    </Card>
  );
};
